export default {
  grid_columns: 2,
  viewType: 'list',
  records: [{
    title: 'My first ad title',
    key: 1,
    price: '199 USD',
    image: '../../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 2,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 3,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 4,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 5,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 6,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 7,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 8,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }, {
    title: 'My first ad title',
    key: 9,
    price: '199 USD',
    image: '../assets/no-image.png',
    favorite: false,
    option: 'for negotiation',
    category: 'VEHICLES > OTHER',
    location: 'Toronto, Ontario',
    date: '28 May 2018',

  }],
};



// WEBPACK FOOTER //
// ./src/store/ads/ads.state.js